import ObservationCardGridView from "@/components/observations/ObservationCardGridView";
import { useAreaName } from "@/hooks/useAreaName";
import type { LayoutContext } from "@/lib/models";
import { type Observation, ObservationService } from "@/services/ObservationService";
import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";

const AreaObservationListPage: React.FC = () => {
  const [observations, setObservations] = useState<Observation[]>([]);  
  const params = useParams();
  const { areaName } = useAreaName(params.areaId!);
  const { setPageName } = useOutletContext<LayoutContext>();

    useEffect(() => {
      setPageName(`Area: ${areaName} Observations`);
    }, [areaName, setPageName]);

  useEffect(() => {
    ObservationService
      .getByAreaId(params.areaId!)
      .then(setObservations);
  }, [params.areaId]);

  return (
    <div className="container mx-auto p-4">
      <ObservationCardGridView observations={observations} pageTitle={`Area: ${areaName} Observations`} />
    </div>
  );
};

export default AreaObservationListPage;
